import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

export const useCheckCameraConnection = () => {
  const { cameraData } = useRemoteBoundStore();

  const isCameraConnected = !!cameraData;

  return { isCameraConnected };
};

export default useCheckCameraConnection;
